export default __webpack_public_path__ + "static/media/bg-about.8657120f.jpg";